import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

import Player from "@vimeo/player";
import { $qs, $qsa } from "../../../src/js/utils/querySelector";
import Lenis from "lenis";
import { lenis } from "../../../src/js/misc.js";

import { SpreadGrid } from "./spreadGrid";

import tailwindConfig from "../../../tailwind.config";

const screenLG = tailwindConfig.theme.screens.lg.replace("px", "");
const screenMD = tailwindConfig.theme.screens.md.replace("px", "");
const screenSM = tailwindConfig.theme.screens.sm.replace("px", "");

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

function home() {
	homeQuote();
	homeVideoFlip();
	homeSchools();

	homeGrid();
}

function homeSchools() {
	const homeSchools = $qs("[data-name='home-schools']");

	if (!homeSchools || window.innerWidth < screenLG) return;

	const schoolCards = $qsa("[data-name='home-school-card']");

	let tl = gsap.timeline({
		scrollTrigger: {
			pin: homeSchools,
			trigger: homeSchools,
			start: "top top",
			// end: "bottom bottom",
			// end: window.innerHeight * 2,
			end: "+=" + window.innerHeight * 2 + "px",

			scrub: 0.1,
			pinSpacing: false,
			markers: false,
		},
	});

	tl.from(schoolCards, { y: window.innerHeight * 0.7 + "px", stagger: 0.2 });
}
function homeVideoFlip() {
	const homeVideoFlip = $qs("[data-name='home-flip-video']");

	if (!homeVideoFlip || window.innerWidth < screenLG) return;

	const videoFront = $qs("[data-name='video-front']", homeVideoFlip);
	const videoFrontText = $qs("[data-name='video-front-text']", homeVideoFlip);
	const videoBack = $qs("[data-name='video-back']", homeVideoFlip);
	const videoBackText = $qs("[data-name='video-back-text']");
	const videoPlayFull1 = $qs("[data-name='video-play-full-1']", homeVideoFlip);
	const videoPlayFull2 = $qs("[data-name='video-play-full-2']", homeVideoFlip);
	const videoScroll = $qs("[data-name='flip-video-scroll']", homeVideoFlip);
	const videoContainWidth = $qs(
		"[data-name='flip-video-contain-width']",
		homeVideoFlip
	);
	const videoContainHeight = $qs(
		"[data-name='flip-video-contain-height']",
		homeVideoFlip
	);

	const videoFrontTextSplit = new SplitText(videoFrontText, {
		type: "chars, words",
		linesClass: "char",
	});

	let splitTextTL = gsap.timeline({
		scrollTrigger: {
			trigger: videoFrontText,
			start: "top 25%",
			// end: "bottom bottom",
			// end: window.innerHeight * 2,
			end: "+=" + window.innerHeight * 0.75 + "px",
			scrub: 0.1,
			//markers: true,
		},
	});

	//console.info(videoFrontTextSplit);
	splitTextTL.from(videoFrontTextSplit.chars, { opacity: 0.2, stagger: 0.1 });

	let initialPinTl = gsap.timeline({
		scrollTrigger: {
			pin: homeVideoFlip,
			trigger: homeVideoFlip,
			start: "top 70%",
			// end: "bottom bottom",
			// end: window.innerHeight * 2,
			end: "+=" + window.innerHeight * 0.7 + "px",

			scrub: 0.1,
			pinSpacing: false,
			markers: false,
		},
	});

	initialPinTl.from(homeVideoFlip, { opacity: 0 });

	let tl = gsap.timeline({
		scrollTrigger: {
			pin: homeVideoFlip,
			trigger: homeVideoFlip,
			start: "top top",
			// end: "bottom bottom",
			// end: window.innerHeight * 2,
			end: "+=" + window.innerHeight * 2 + "px",

			scrub: 0.1,
			pinSpacing: false,
			markers: false,
		},
	});

	tl.to(videoScroll, { autoAlpha: 0, duration: 0.1 })
		.to(videoFront, { opacity: 1, duration: 0.5 })
		.to(videoFront, { rotateY: -180, ease: "power1.inOut", duration: 1.3 })
		.to(videoFront, { rotateZ: 180, ease: "power1.inOut", duration: 1 }, "<")
		.to(videoFrontText, { autoAlpha: 0, duration: 0.1 }, "<")
		.to(videoPlayFull1, { autoAlpha: 0, duration: 0.1 }, "<")
		.from(
			videoBack,
			{ rotateY: -180, ease: "power1.inOut", duration: 1.3 },
			"<"
		)
		.from(videoBack, { rotateZ: -180, ease: "power1.inOut", duration: 1 }, "<")
		// .to(videoContainHeight, { scale: 0.8, duration: 0.5 }, "<")
		// .to(videoContainHeight, { scale: 1, duration: 0.5 }, "-=0.5")
		.to(
			videoContainWidth,
			{
				y: "-80px",
				padding: 0,
				width: `${window.innerWidth}px`,
				duration: 0.5,
			},
			"scale"
		)
		.to(
			videoContainHeight,
			{
				height: `${window.innerHeight}px`,
				duration: 0.5,
			},
			"scale"
		)
		.from(
			videoPlayFull2,
			{
				autoAlpha: 0,
				duration: 0.1,
			},
			"-=0.2"
		)
		.from("body", { background: "#002b3c", duration: 0.01 });

	let tl2 = gsap.timeline({
		scrollTrigger: {
			trigger: videoBackText,
			start: "top bottom",
			// end: "bottom bottom",
			// end: window.innerHeight * 2,
			end: "+=" + window.innerHeight / 5 + "px",

			scrub: 0.1,
			pinSpacing: false,
			markers: false,
		},
	});

	//console.info("seco sdf");
	tl2.from(videoBackText, { autoAlpha: 0 });
}
function homeQuote() {
	const homeQuote = $qs("[data-name='home-quote']");

	if (!homeQuote || window.innerWidth < screenMD) return;

	let tl = gsap.timeline({
		scrollTrigger: {
			pin: homeQuote,
			trigger: homeQuote,
			start: "top top",
			// end: "bottom bottom",
			// end: window.innerHeight * 2,
			scrub: 0.1,
			pinSpacing: false,
			// markers: true,
		},
	});

	tl.from(homeQuote, { opacity: 0 });
}

function homeGrid() {
	const grid = $qs("[data-name='home-grid']");
	const gridWrapper = $qs("[data-name='home-grid-wrapper']");
	const gridIntro = $qs("[data-name='home-grid__intro']");
	const gridIntro1 = $qs("[data-name='home-grid__intro-1']");
	const gridIntro2 = $qs("[data-name='home-grid__intro-2']");
	const vimeoContain = $qs("#vimeo-contain");

	if (!grid) return;
	if (window.innerWidth > screenLG) {
		new SpreadGrid(grid);
	}

	const studentTestimonials = grid.querySelectorAll(
		'[data-target="student-testimonial"]'
	);
	// const videoPlayer = document.getElementById("myVideo");

	const regularCol = gsap.utils.toArray(".scroll-regular");
	const reverseCol = gsap.utils.toArray(".scroll-reverse");

	if (window.innerWidth > screenMD) {
		let tl = gsap.timeline({
			scrollTrigger: {
				pin: gridWrapper,
				trigger: gridWrapper,
				start: "top top",
				end: window.innerHeight * 2,
				scrub: 0.1,
				pinSpacing: false,
				markers: false,
				onEnterBack: () => {
					gsap.set(gridWrapper, { opacity: 1 });
				},
				onLeave: () => {
					gsap.set(gridWrapper, { opacity: 0 });
				},
			},
		});

		tl.fromTo(
			regularCol,
			{ top: `${window.innerHeight}px` },
			{
				top: `-${(reverseCol[0].offsetHeight + 30) * 4}px`, // has to be "top" property because of spreading the elements always correctly in position.
				ease: "none",
			}
		)
			.fromTo(
				reverseCol,
				{
					top: `-${(reverseCol[0].offsetHeight + 30) * 4}px`,
				},
				{
					top: `${window.innerHeight}px`, // has to be "top" property because of spreading the elements always correctly in position.
					ease: "none",
				},
				"<"
			)
			.fromTo(
				gridIntro,
				{ opacity: 1 },
				{ opacity: 0, duration: 0.15 },
				"<+=0.02"
			);

		gsap.set(grid, { visibility: "visible" });
	} else {
		gsap.set(grid, { visibility: "visible" });
	}

	let loadTL = gsap.timeline({ delay: 0.5 });
	loadTL
		.fromTo(gridIntro1, { opacity: 0 }, { opacity: 1, duration: 1 }, "start")
		.fromTo(gridIntro2, { opacity: 0 }, { opacity: 1, duration: 1 }, "start");

	//console.info(Lenis);
	if (window.innerWidth > screenMD) {
		loadTL.add(() => {
			if (lenis.animatedScroll < 10) {
				const highlight = document.querySelector(
					'[data-name="home-grid"] [data-highlight]'
				);

				if (
					document.querySelector("body").classList.contains("logged-in") &&
					highlight
				) {
					//const hightlightPositionToTop = highlight.getBoundingClientRect().top;
					//const highlightHeight         = highlight.offsetHeight;
					const result = window.innerHeight - 180;

					lenis.scrollTo(result, { duration: 2, lock: true });
				} else {
					lenis.scrollTo(window.innerHeight * 0.68, {
						duration: 2,
						lock: true,
					});
				}
			}
			// window.scrollTo({
			// 	top: window.innerHeight * 0.65,
			// 	behavior: "smooth",
			// });
		}, "+=1");
	}

	// const homeVideoPopup = $qs('[data-name="home-video-popup"]');
	// gsap.set(homeVideoPopup, {
	// 	skewX: -45,
	// 	scale: 0.3,
	// 	rotateX: -90,
	// 	visibility: "hidden",
	// });

	studentTestimonials.forEach((item, index) => {
		const tlItem = gsap.timeline();
		const videoID = item.dataset.videoId;
		const popupId = item.dataset.popupId;
		const popup = $qs('[data-value="' + popupId + '"]');
		const popupIframe = $qs('[data-name="iframe-contain"]', popup);

		gsap.set(popup, {
			skewX: -45,
			scale: 0.3,
			rotateX: -90,
			visibility: "hidden",
		});

		//console.info(videoID);
		//console.info(popupIframe);
		const options = {
			id: videoID,
			loop: true,
			controls: false,
		};
		const player = new Player(popupIframe, options);

		player.setVolume(0);
		player.play().then(function () {
			setTimeout(() => {
				player.pause();
				player.setCurrentTime(0);
			}, 2000);
			// the video was played
		});

		gsap.set(item, { backfaceVisibility: "hidden" });

		item.addEventListener("click", (e) => {
			//console.info("testimonial click");

			const videoTitle = item.dataset.videoTitle;
			const videoDescription = item.dataset.videoDescription;
			const videoPlayToggle = $qs('[data-name="play-video"]', popup);
			const videoVolumeToggle = $qs('[data-name="volume-video"]', popup);
			const videoRestart = $qs('[data-name="restart-video"]', popup);

			// $qs('[data-name="home-video-popup-title"]').innerHTML = videoTitle;
			// $qs('[data-name="home-video-popup-description"]').innerHTML =
			// 	videoDescription;

			videoRestart.addEventListener("click", function () {
				player.setCurrentTime(0);
			});

			videoPlayToggle.addEventListener("click", function () {
				player.getPaused().then(function (paused) {
					if (paused) {
						player.play();
						gsap.to($qs('[data-name="play-video-pause"]', videoPlayToggle), {
							opacity: 1,
						});
						gsap.to($qs('[data-name="play-video-play"]', videoPlayToggle), {
							opacity: 0,
						});
					} else {
						player.pause();
						gsap.to($qs('[data-name="play-video-pause"]', videoPlayToggle), {
							opacity: 0,
						});
						gsap.to($qs('[data-name="play-video-play"]', videoPlayToggle), {
							opacity: 1,
						});
					}
				});
			});

			videoVolumeToggle.addEventListener("click", function () {
				player.getVolume().then(function (volume) {
					if (volume == 0) {
						player.setVolume(0.8);
						gsap.to(
							$qs('[data-name="volume-video-sound"]', videoVolumeToggle),
							{ opacity: 1 }
						);
						gsap.to($qs('[data-name="volume-video-mute"]', videoVolumeToggle), {
							opacity: 0,
						});
					} else {
						player.setVolume(0);
						gsap.to(
							$qs('[data-name="volume-video-sound"]', videoVolumeToggle),
							{ opacity: 0 }
						);
						gsap.to($qs('[data-name="volume-video-mute"]', videoVolumeToggle), {
							opacity: 1,
						});
					}
				});
			});

			gsap.set(grid, { pointerEvents: "none" });

			const clickedEl = e.srcElement;

			const clickedElPos = {
				x:
					clickedEl.getBoundingClientRect().x +
					clickedEl.getBoundingClientRect().width / 2,
				y:
					clickedEl.getBoundingClientRect().y +
					clickedEl.getBoundingClientRect().height / 2,
			};

			tlItem
				.to(item, {
					rotateY: -180,
					rotateZ: 90,
					scale: 1.5,
					duration: 0.6,
				})
				// .to(item, {
				// 	scaleX: 0.5,
				// 	duration: 1,
				// })
				.fromTo(
					popup,
					{
						skewX: -45,
						scale: 0.3,
						rotateX: -90,
						opacity: 1,
					},
					{
						visibility: "visible",
						opacity: 1,
						skewX: 0,
						rotateX: 0,
						duration: 0.3,
						scale: 1,
						pointerEvents: "auto",
						transformOrigin: `${clickedElPos.x}px ${clickedElPos.y}px`,
					},
					"-=0.2"
				)
				.to(grid, { opacity: 0, duration: 0.2 }, "-=0.2")
				.add(() => {
					player.setVolume(0.8);

					// videoPlayToggle click
					if (window.innerWidth > 767) {
						videoPlayToggle.click();
					}

					//player.play();
				})
				.set(item, {
					rotateY: 0,
					rotateZ: 0,
					scale: 1,
				});
		});

		const closeVimeoPopup = $qs('[data-name="close-vimeo-popup"]', popup);
		closeVimeoPopup.addEventListener("click", function () {
			const tl = gsap.timeline();

			tl.add(() => {
				player.pause();
				// console.info("remove iframe");
				// const iframe = $qs("iframe", vimeoContain);
				// iframe.remove();
			})
				.to(grid, { opacity: 1, duration: 0.1 }, "start")
				.to(
					popup,
					{
						scale: 1.4,
						opacity: 0,
						duration: 0.3,
						// visibility: "hidden",
						transformOrigin: "center",
					},
					"start"
				)
				.set(popup, {
					visibility: "hidden",
				});
		});

		// Toggle testimonial content box (to have more space to watch the video)
		const toggleTestimonialClose = $qs('[data-name="content-close"]', popup);
		if (toggleTestimonialClose) {
			toggleTestimonialClose.addEventListener("click", function (e) {
				const testimonialContent = this.parentNode;
				const testimonialCloseIcon = this;
				const testimonialOpenIcon = this.nextElementSibling;

				gsap.to(testimonialContent, {
					xPercent: -100,
					x: 30,
					duration: 0.3,
					ease: "power2.out",
				});
				gsap.to(testimonialCloseIcon, {
					opacity: 0,
					duration: 0.3,
					ease: "power2.out",
				});
				gsap.to(testimonialOpenIcon, {
					opacity: 1,
					duration: 0.3,
					ease: "power2.out",
				});
			});
		}

		const toggleTestimonialOpen = $qs('[data-name="content-open"]', popup);
		if (toggleTestimonialOpen) {
			toggleTestimonialOpen.addEventListener("click", function (e) {
				const testimonialContent = this.parentNode;
				const testimonialCloseIcon = this.previousElementSibling;
				const testimonialOpenIcon = this;

				gsap.to(testimonialContent, {
					xPercent: 0,
					x: 0,
					duration: 0.3,
					ease: "power2.out",
				});
				gsap.to(testimonialCloseIcon, {
					opacity: 1,
					duration: 0.3,
					ease: "power2.out",
				});
				gsap.to(testimonialOpenIcon, {
					opacity: 0,
					duration: 0.3,
					ease: "power2.out",
				});
			});
		}
	});
}

export { home };
